import { render } from "./categoryattributeicon.vue?vue&type=template&id=8e342bfa"
import script from "./categoryattributeicon.vue?vue&type=script&lang=js"
export * from "./categoryattributeicon.vue?vue&type=script&lang=js"

import "./categoryattributeicon.vue?vue&type=style&index=0&id=8e342bfa&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__